var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61914 15.3926H16.6191V16.8926H1.61914V15.3926ZM3.11914 9.39258H4.61914V14.6426H3.11914V9.39258ZM6.86914 9.39258H8.36914V14.6426H6.86914V9.39258ZM9.86914 9.39258H11.3691V14.6426H9.86914V9.39258ZM13.6191 9.39258H15.1191V14.6426H13.6191V9.39258ZM1.61914 5.64258L9.11914 1.89258L16.6191 5.64258V8.64258H1.61914V5.64258ZM3.11914 6.56958V7.14258H15.1191V6.56958L9.11914 3.56958L3.11914 6.56958ZM9.11914 6.39258C8.92023 6.39258 8.72946 6.31356 8.58881 6.17291C8.44816 6.03226 8.36914 5.84149 8.36914 5.64258C8.36914 5.44367 8.44816 5.2529 8.58881 5.11225C8.72946 4.9716 8.92023 4.89258 9.11914 4.89258C9.31805 4.89258 9.50882 4.9716 9.64947 5.11225C9.79012 5.2529 9.86914 5.44367 9.86914 5.64258C9.86914 5.84149 9.79012 6.03226 9.64947 6.17291C9.50882 6.31356 9.31805 6.39258 9.11914 6.39258Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.49f4f4d75958580bf7182ace6fde9dd0.svg";
export { ForwardRef as ReactComponent };